module.exports = __webpack_public_path__ + "static/media/techwiz.e1aeca46.jpeg";